export default "__VITE_ASSET__DoiTbFq1__"